<template>
  <section class="section-main">
    <div class="main-header">
      <div class="header-title">
        CUPONS DE DESCONTO
        <div class="dot"></div>
        <div>{{ coupons.length }}</div>
      </div>
      <router-link
        to="/master/create-coupon"
        exact
        tag="li"
        :title="'Criar novo cupom'"
        class="box-add-icon"
        v-tippy="{
          placement: 'right',
          theme: 'light',
          inertia: true,
          arrow: true,
          animation: 'perspective',
        }"
      >
        <fa size="lg" icon="plus"></fa>
      </router-link>
    </div>
    <div class="table-div">
      <table id="table_coupons">
        <thead>
          <th class="w-30">Nome</th>
          <th class="w-15">Expiração</th>
          <th class="w-15">Desconto</th>
          <th class="w-15">Quantidade</th>
          <th class="w-15 text-center">Ações</th>
        </thead>
        <tr
          v-for="coupon of coupons"
          :key="coupon.id"
          class="item"
          :class="{ disabled: coupon.status != 'active' }"
        >
          <td>{{ coupon.name }}</td>
          <td>{{ moment(coupon.expirationDate).format("DD/MM/YYYY HH:mm") }}</td>
          <td>
            {{
            parseFloat(coupon.amount).toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
            })
            }}
          </td>
          <td>{{ coupon.quantity }}</td>
          <td>
            <div class="icons">
              <div>
                <router-link :to="'/master/edit-coupon/' + coupon.id">
                  <fa size="lg" icon="edit" />
                </router-link>
              </div>
              <div @click="openRemoveModal(coupon.id)">
                <fa size="lg" icon="trash" />
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <app-modal
      v-if="showRemoveModal"
      modalHeight="30%"
      footerPosition="center"
      @close="closeRemoveModal()"
      @action="removeCoupon()"
      :btnActionName="'Confirmar'"
    >
      <template slot="header">
        <div class="modal-header">Excluir cupom</div>
      </template>
      <template slot="body">
        <div class="text-center">Tem certeza que deseja excluir esse cupom?</div>
      </template>
    </app-modal>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ZepplinCouponsAPI from "../../../api/zepplin/coupons";
import moment from "moment";

export default {
  data() {
    return {
      coupons: [],
      showRemoveModal: false,
      selectedCoupon: null
    };
  },
  methods: {
    ...mapActions("toast", ["showToast", "showError"]),

    async getCoupons() {
      this.coupons = await ZepplinCouponsAPI.getAll({
        masterToken: this.zepplinMasterToken
      }).then(res => res);
      window.removeAppLoading();
    },

    async reloadCoupons() {
      (this.coupons = []), this.getCoupons();
    },

    async removeCoupon() {
      await ZepplinCouponsAPI.delete(
        {
          masterToken: this.zepplinMasterToken
        },
        this.selectedCoupon
      ).then(() => {
        this.closeRemoveModal();
        this.showToast({ type: "success", message: "Cupom excluido" });
        this.reloadCoupons();
      });
    },

    openRemoveModal(id) {
      this.selectedCoupon = id;
      this.showRemoveModal = true;
    },

    closeRemoveModal() {
      this.selectedCoupon = null;
      this.showRemoveModal = false;
    }
  },
  mounted() {
    window.showAppLoading();
    window.setAppLoadingText("Carregando lista...");
    this.getCoupons();
  },
  computed: {
    ...mapState("auth", ["zepplinMasterToken"])
  }
};
</script>

<style scoped>
.section-main {
  width: 100%;
  min-height: 100%;
  padding: 70px;
  overflow-y: scroll;
  background-color: var(--bg-color--2);
}

.main-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.header-title {
  display: flex;
  font-weight: 600;
}

.box-add-icon {
  width: 50px;
  height: 30px;
  border-radius: 50px;
  background: linear-gradient(89.39deg, #0072e4 -0.59%, #25a0a8 100.95%);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.box-add-icon:hover {
  background: #0072e4;
}

.table-div {
  margin-top: 10px;
}

#table_coupons tbody tr:nth-child(odd) {
  background: rgba(22, 26, 29, 0.404);
}

#table_coupons {
  margin-top: 20px;
  width: 100%;
}

#table_coupons thead th {
  text-align: left;
  padding-right: 20px;
}

#table_coupons td {
  margin-right: 10px;
  font-size: 14px;
}

.item {
  height: 40px;
}

.w-10 {
  width: 10% !important;
}

.w-15 {
  width: 15% !important;
}

.w-25 {
  width: 25% !important;
}

.w-30 {
  width: 30% !important;
}

.icons {
  display: flex;
  justify-content: center;
}

.icons div {
  margin-right: 15px;
  cursor: pointer;
}

.disabled {
  opacity: 0.5;
}

.text-center {
  text-align: center !important;
}

.modal-header {
  color: #c3c5c6;
}
</style>
